export default __webpack_public_path__ + "images/f28cf1ebdfe8f8523811b5a4e6128f58-2_web_1919x543.webp";